import React from "react"
// import { Link } from "gatsby"
import { Helmet } from "react-helmet"

import Layout from "../components/layout"
// import Image from "../components/image"
import SEO from "../components/seo"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <Helmet>
      <link
        href="https://fonts.googleapis.com/css2?family=Oswald:wght@200;300&display=swap"
        rel="stylesheet"
      />
    </Helmet>
    <h1>Hi people!!</h1>
    <h3>Welcome to the setState({"{}"}) landing page</h3>
    <p>
      Your one-stop-shop for blazing fast, static or server side rendered
      websites, applications and PWAs
    </p>
    <h4>In React.js, Node.js, GraphQL, Vue.js</h4>
    <h6>Click the button below and get in touch</h6>
    <a href="mailto:info@portugles.com" target="_blank" rel="noreferrer">
      <button
        style={{
          backgroundColor: "rgb(225, 221, 227)",
          color: "#1e221c",
        }}
      >
        info@setstate.com
      </button>
    </a>{" "}
    {/*<div style={{ maxWidth: `300px`, marginBottom: `1.45rem` }}></div>
    <Link to="/page-2/">Go to page 2</Link> <br />
    <Link to="/using-typescript/">Go to "Using TypeScript"</Link>*/}
  </Layout>
)

export default IndexPage
